const reasons = [
	'Низкий апрув',
	'Низкая маржа',
	'Проблемы с трафиком',
	'Нету товарной КАПы',
	'Нету КАПы СС',
	'Другое'
];

export default reasons.map((reason) => ({ value: reason, label: reason }));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/alerts-analytics/reasons.js